<template>

    <div class="w-full">

        <div class="w-full container mx-auto flex flex-wrap items-center pb-3 md:pb-0 max-w-5xl mt-6 px-4">
            <div class="w-full">
                <h1 class="text-3xl font-semibold">Privacy Policy</h1>
                <strong>Last updated: 1/3/19</strong>
            </div>
            <div>
                <p class="py-1">Live Storms Media built the LSM2GO app as a Free app. This SERVICE is provided by Live Storms Media at no cost and is intended for use as is.</p>

                <p class="py-1">This page is used to inform visitors regarding our policies with the collection, use, and disclosure of Personal Information if anyone decided to use our Service.</p>

                <p class="py-1">If you choose to use our Service, then you agree to the collection and use of information in relation to this policy. The Personal Information that we collect is used for providing and improving the Service. We will not use or share your information with anyone except as described in this Privacy Policy.</p>

                <p class="py-1">The terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, which is accessible at LSM2GO unless otherwise defined in this Privacy Policy.</p>

                <h4 class="font-bold text-lg mt-4">Information Collection and Use</h4>

                <p class="py-1">For a better experience, while using our Service, we may require you to provide us with certain personally identifiable information, including but not limited to name, email address, device id. The information that we request will be retained by us and used as described in this privacy policy.</p>

                <p class="py-1">The app does use third party services that may collect information used to identify you.</p>

                <p class="py-1">Link to privacy policy of third party service providers used by the app</p>

                <ul class="list-disc pl-10">
                    <li><a class="text-blue-600" href="https://policies.google.com/privacy?hl=en-US">Google Play Services</a></li>
                    <li><a class="text-blue-600" href="https://www.apple.com/legal/privacy/en-ww/">Apple App Store</a></li>
                </ul>

                 <h4 class="font-bold text-lg mt-4">Log Data</h4>

                <p>We want to inform you that whenever you use our Service, in a case of an error in the app we collect data and information (through third party products) on your phone called Log Data. This Log Data may include information such as your device Internet Protocol (“IP”) address, device name, operating system version, the configuration of the app when utilizing our Service, the time and date of your use of the Service, and other statistics.</p>

                <h4 class="font-bold text-lg mt-4">Cookies</h4>

                <p>Cookies are files with a small amount of data that are commonly used as anonymous unique identifiers. These are sent to your browser from the websites that you visit and are stored on your device's internal memory.</p>

                <p>This Service does not use these “cookies” explicitly. However, the app may use third party code and libraries that use “cookies” to collect information and improve their services. You have the option to either accept or refuse these cookies and know when a cookie is being sent to your device. If you choose to refuse our cookies, you may not be able to use some portions of this Service.</p>

                <h4 class="font-bold text-lg mt-4">Service Providers</h4>

                <p>We may employ third-party companies and individuals due to the following reasons:</p>

                <ul class="list-disc pl-10">
                    <li>To facilitate our Service;</li>
                    <li>To provide the Service on our behalf;</li>
                    <li>To perform Service-related services; or</li>
                    <li>To assist us in analyzing how our Service is used.</li>
                </ul>

                <p class="py-1">We want to inform users of this Service that these third parties have access to your Personal Information. The reason is to perform the tasks assigned to them on our behalf. However, they are obligated not to disclose or use the information for any other purpose.</p>

                <h4 class="font-bold text-lg mt-4">Security</h4>

                <p>We value your trust in providing us your Personal Information, thus we are striving to use commercially acceptable means of protecting it. But remember that no method of transmission over the internet, or method of electronic storage is 100% secure and reliable, and we cannot guarantee its absolute security.</p>

                <h4 class="font-bold text-lg mt-4">Links to Other Sites</h4>

                <p>This Service may contain links to other sites. If you click on a third-party link, you will be directed to that site. Note that these external sites are not operated by us. Therefore, we strongly advise you to review the Privacy Policy of these websites. We have no control over and assume no responsibility for the content, privacy policies, or practices of any third-party sites or services.</p>

                <h4 class="font-bold text-lg mt-4">Children’s Privacy</h4>

                <p>These Services do not address anyone under the age of 13. We do not knowingly collect personally identifiable information from children under 13. In the case we discover that a child under 13 has provided us with personal information, we immediately delete this from our servers. If you are a parent or guardian and you are aware that your child has provided us with personal information, please contact us so that we will be able to do necessary actions.</p>

                <h4 class="font-bold text-lg mt-4">Changes to This Privacy Policy</h4>

                <p>We may update our Privacy Policy from time to time. Thus, you are advised to review this page periodically for any changes. We will notify you of any changes by posting the new Privacy Policy on this page. These changes are effective immediately after they are posted on this page.</p>

                <h4 class="font-bold text-lg mt-4">Contact Us</h4>

                <p>If you have any questions or suggestions about our Privacy Policy, do not hesitate to contact us at brett@livestormsmedia.com.</p>
            </div>
        </div>
    </div>

</template>

<script>
    import * as Config from '../../config'
    import { mapState, mapGetters } from 'vuex';
    import { EventBus } from '../../utils/events';


	export default {
	}
</script>

<style scoped>

    body {
        background-color: #EFF1F3;
    }

    .h-100 {
        min-height: 100vh;
    }

    .container-fluid {
        height: 100%;
    }

    .card {
        margin-bottom: 20px;
    }

    .card-block {
        -webkit-box-flex: 1;
        -webkit-flex: 1 1 auto;
        -ms-flex: 1 1 auto;
        flex: 1 1 auto;
        padding: 1.25rem;
    }

    a:hover {
        text-decoration: none;
    }

    .actionable {
        color: #007bff;
        cursor: pointer;
    }

</style>